/* Novelys NFC — panier : recomposition au meilleur tarif et boutons − / +.

   Le calcul du meilleur tarif est fait en Liquid, cote serveur. Ce fichier ne
   fait qu'envoyer le formulaire. On n'utilise pas l'API AJAX du panier : un
   envoi de formulaire vers /cart fonctionne meme quand fetch est bride.

   VERROU — pourquoi il est temporel et pas definitif.
   Une premiere version marquait l'etat du panier comme « deja tente » pour
   toute la session. Resultat : un client qui revenait sur le meme panier ne
   voyait plus jamais la correction, juste le bouton. Le verrou ne sert qu'a
   empecher une boucle de rechargement ; 15 secondes suffisent.

   MESSAGE — pourquoi textContent et pas innerHTML.
   Le message transite par sessionStorage, qui est ecrivable par n'importe quel
   script de l'origine. Un innerHTML alimente par du stockage est un point
   d'injection, meme si aujourd'hui la seule source est notre propre Liquid.
   Le message est du texte simple : textContent suffit et supprime le risque. */
(function () {
  'use strict';
  if (window.__nvCartReady) return;
  window.__nvCartReady = true;

  var CLE_MSG = 'nv-cart-msg';
  var DELAI_VERROU = 15000;

  function lire(cle) { try { return sessionStorage.getItem(cle); } catch (e) { return null; } }
  function ecrire(cle, val) { try { sessionStorage.setItem(cle, val); } catch (e) {} }

  function afficherMessage() {
    var zone = document.querySelector('[data-nv-cart-msg]');
    if (!zone) return;
    var msg = lire(CLE_MSG);
    if (!msg) return;
    try { sessionStorage.removeItem(CLE_MSG); } catch (e) {}
    var p = document.createElement('p');
    p.className = 'nv-note-ok';
    p.setAttribute('role', 'status');
    p.textContent = msg;
    zone.textContent = '';
    zone.appendChild(p);
  }

  function corriger() {
    var form = document.getElementById('nv-cart-fix');
    /* Pas de formulaire : le panier est deja au meilleur tarif. */
    if (!form) { afficherMessage(); return; }

    var cle = 'nv-cart-fix:' + (form.getAttribute('data-nv-sig') || '');
    var precedent = parseInt(lire(cle) || '0', 10);
    var maintenant = Date.now();

    /* Deja tente il y a moins de 15 s : on ne renvoie pas, sinon boucle. Le
       bouton reste la, le client peut cliquer lui-meme. */
    if (precedent && maintenant - precedent < DELAI_VERROU) { afficherMessage(); return; }

    ecrire(cle, String(maintenant));
    ecrire(CLE_MSG, form.getAttribute('data-nv-msg') || '');
    form.submit();
  }

  /* ---------- Boutons − / + ----------
     Ils changent le champ tout de suite, puis envoient le formulaire apres une
     courte pause : plusieurs clics d'affilee ne provoquent qu'un rechargement. */
  function steppers() {
    document.querySelectorAll('.nv-cart__qty').forEach(function (pill) {
      if (pill.dataset.nvStep === '1') return;
      var input = pill.querySelector('input[type="number"]');
      if (!input) return;
      pill.dataset.nvStep = '1';

      var form = input.form;
      var maj = form ? form.querySelector('button[name="update"]') : null;
      var minus = pill.querySelector('[data-nv-step="-1"]');
      var attente = 0;

      function refleter() {
        var v = parseInt(input.value, 10);
        if (minus) minus.disabled = !(v > 1);
      }

      function envoyer() {
        clearTimeout(attente);
        attente = setTimeout(function () {
          if (!form) return;
          if (form.requestSubmit && maj) form.requestSubmit(maj);
          else form.submit();
        }, 650);
      }

      pill.querySelectorAll('[data-nv-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pas = parseInt(btn.getAttribute('data-nv-step'), 10) || 0;
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = 1;
          v = v + pas;
          if (v < 0) v = 0;
          input.value = String(v);
          refleter();
          envoyer();
        });
      });

      input.addEventListener('change', function () { refleter(); envoyer(); });
      refleter();
    });
  }

  function boot() {
    steppers();
    corriger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
